<template>
  <resizable-common-dialog
      ref="dialog"
      title="Import JSON"
      :dialog-visible.sync="visible"
      rules="rules"
      start-dialog-height="360"
      start-dialog-width="350"
  >
    <template v-slot:body>
      <v-spacer />
      <v-row dense>
        <v-col class="pa-0">
          <strong>UID: </strong><strong>{{config?.uid}}</strong>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col class="pa-0">
          <strong>Group: </strong><strong>{{config?.group}}</strong>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col class="pa-0">
          <strong>Tag: </strong><strong>{{config?.tag}}</strong>
        </v-col>
      </v-row>
      <v-row dense>
        <v-file-input
            v-model="file"
            ref="uploaderJson"
            accept="application/json"
            label="Import from JSON file"
            show-size
            @change="onFileChangedJson">
        </v-file-input>
      </v-row>
      <v-row dense>
        <v-alert type="warning" dense>
          Warning: Importing configuration will overwrite all data from config.
        </v-alert>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="blue darken-1" text @click="hide">Cancel</v-btn>
      <v-btn color="blue darken-1" text @click="importConfiguration">Import</v-btn>
    </template>
  </resizable-common-dialog>
</template>

<script>
import ResizableCommonDialog from "@/modules/common/dialog/resizable-common-dialog.vue";
import {ViewRules} from "@/common/ViewRules";

export default {
  name: "c-import-config-popup",
  components: {ResizableCommonDialog},
  data: () => ({
    visible: false,
    rules: ViewRules.CREATE,
    resolve: null,
    reject: null,
    sourceData: null,
    targetData: null,
    file: null,
    config: null,
  }),
  methods: {
    show(config, sourceData) {
      this.sourceData = sourceData;
      this.config = config;
      this.visible = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    hide() {
      this.visible = false;
    },
    importConfiguration() {
      const finalData = JSON.parse(JSON.stringify(this.targetData));
      this.visible = false;
      if (this.resolve) {
        this.targetData = null;
        this.config = null;
        this.sourceData = null;
        this.resolve(finalData);
      }
    },
    onFileChangedJson() {
      if (!this.file) {
        return;
      }
      this.file.text()
          .then((data)=>{
            this.targetData = JSON.parse(JSON.parse(JSON.stringify(data)));
          }).catch((error) => {
        this.$alert("Failed to read file: " + error.message);
      });
    },
  }
}
</script>